// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"148":"Detail","422":"userInfo","966":"login"}[chunkId] + "." + {"148":"ac94f064","422":"b0fe67ae","966":"4d239679"}[chunkId] + ".css";
};